import { DataKeyValueStringInterface } from 'pf-frontend-common/dist/module/data/key-value/string.interface';

import { MortgageCampaignEnum } from 'common/module/mortgage/campaign.enum';

export const MortgageCampaignCss: {
  [key: string]: DataKeyValueStringInterface;
} = {
  [MortgageCampaignEnum.mfCalculator]: __css('css/async-mfcalculator.css'),
  [MortgageCampaignEnum.mfPreApproved]: __css('css/async-mfpreapproved.css'),
  [MortgageCampaignEnum.mfPreApproved2]: __css('css/async-mfpreapproved2.css'),
  [MortgageCampaignEnum.mfPreApproved3]: __css('css/async-mfpreapproved3.css'),
  [MortgageCampaignEnum.mfPreApproved4]: __css('css/async-mfpreapproved4.css'),
  [MortgageCampaignEnum.mfestimated]: __css('css/async-mfestimated.css'),
  [MortgageCampaignEnum.mfestimated2]: __css('css/async-mfestimated2.css'),
  [MortgageCampaignEnum.mfestimated3]: __css('css/async-mfestimated3.css'),
  [MortgageCampaignEnum.bmcePreApproved]: __css('css/async-bmcepreapproved.css'),
  [MortgageCampaignEnum.saroutyCreditSimulator]: __css('css/async-saroutycreditsimulator.css'),
  [MortgageCampaignEnum.bankaudiCalculator]: __css('css/async-bankaudicalculator.css'),
  [MortgageCampaignEnum.shlCalculator]: __css('css/async-shlcalculator.css'),
  [MortgageCampaignEnum.bidayaCalculator]: __css('css/async-bidayacalculator.css'),
  [MortgageCampaignEnum.bidayaPreapproved]: __css('css/async-bidayapreapproved.css'),
  [MortgageCampaignEnum.rzsaudicalculator]: __css('css/async-mortgagecampaigncalculator.css'),
  [MortgageCampaignEnum.nbbbahraincalculator]: __css('css/async-mortgagecampaigncalculator.css'),
};
